/* eslint-disable no-shadow */

export const state = {
    hiddenSegments: [],
};

export const getters = {
    hiddenSegments: state => state.hiddenSegments,
    isHidden: state => id => state.hiddenSegments.includes(id),
};

export const mutations = {
    hide(state, id) {
        const hiddenSegments = [...state.hiddenSegments];
        hiddenSegments.push(id);
        state.hiddenSegments = [...new Set(hiddenSegments)];
    },
    show(state, id) {
        const index = state.hiddenSegments.indexOf(id);
        if (index > -1) {
            state.hiddenSegments.splice(index, 1);
        }
    },
    reset(state) {
        state.hiddenSegments = [];
    },
};

export const actions = {
    hideSegment({commit}, {id}) {
        commit('hide', id);
    },
    showSegment({commit}, {id}) {
        commit('show', id);
    },
    toggleSegment({commit, getters}, {id}) {
        commit(getters.isHidden(id) ? 'show' : 'hide', id);
    },
    reset({commit}) {
        commit('reset');
    },
};
